import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import _ from 'underscore';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import Menu from 'ui-library/menus/Menu';
import {OptionData} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

export enum DisabledRenderType {
  TEXT = 'TEXT',
  DROPDOWN = 'DROPDOWN',
}

interface ReviewLifecycleConfigurationFieldProps {
  id: string;
  className: string;
  optionDatas: Array<OptionData>;
  dropdownLabel: string;
  selectedOption: OptionData;
  handleSelectionChange: (opt: OptionData) => void;
  disabled: boolean;
  // When disabled is true, this option lets the caller configure whether the disabled field is rendered
  // as plain text or a disabled dropdown.
  disabledRenderType?: DisabledRenderType;
  help?: string;
  dataTestAttrs?: DataTestAttrs;
}

// TODO (BNCH-46349) Refactor similar dropdown components
export default function ReviewLifecycleConfigurationField({
  id,
  className,
  optionDatas,
  dropdownLabel,
  selectedOption,
  handleSelectionChange,
  disabled,
  disabledRenderType = DisabledRenderType.DROPDOWN,
  help,
  dataTestAttrs,
}: ReviewLifecycleConfigurationFieldProps): JSX.Element {
  const inputId = _.uniqueId(id);
  return (
    <div className={className}>
      <InputWrapper
        id={inputId}
        label={dropdownLabel}
        labelStyle={FieldLabel.STYLES.LABEL}
        help={help}
        isRequired={!disabled}
      >
        {disabled && disabledRenderType === DisabledRenderType.TEXT ? (
          <div>{selectedOption.name.toString()}</div>
        ) : (
          <SelectDropdown
            id={inputId}
            className={css(styles.flexGrow)}
            displayName={selectedOption.name}
            menu={
              <Menu
                value={selectedOption.name}
                height={Menu.HEIGHTS.MEDIUM}
                width={Menu.WIDTHS.FULL}
                scrollable={true}
              >
                {optionDatas.map((opt) => (
                  <Option
                    className={opt.className}
                    key={opt.name.toString()}
                    value={opt}
                    onSelect={handleSelectionChange}
                  >
                    {opt.name}
                  </Option>
                ))}
              </Menu>
            }
            dataTestAttrs={dataTestAttrs}
            disabled={disabled}
          />
        )}
      </InputWrapper>
    </div>
  );
}

const styles = StyleSheet.create({
  flexGrow: {
    flex: 1,
  },
});
